import clsx from 'clsx';
import { KeyboardEvent, useCallback } from 'react';

import { KeyCode } from '@vestico/utils';

import style from './optionsgrid.module.css';

export interface OptionsGridInput {
  name: string;
  options: string[];
  selectedOptionIndex: number | undefined;
  didUpdateOption: (index: number) => void;
}

export const OptionsGrid = ({ name, options, selectedOptionIndex, didUpdateOption }: OptionsGridInput) => {
  const updateSelectedOptionIndex = useCallback(
    (index: number) => () => {
      didUpdateOption(index);
    },
    [didUpdateOption]
  );

  const handleKeyUp = useCallback(
    (index: number) => (e: KeyboardEvent<HTMLDivElement>) => {
      e.preventDefault();
      e.stopPropagation();

      if (e.code === KeyCode.enter) {
        updateSelectedOptionIndex(index)();
      }
    },
    [updateSelectedOptionIndex]
  );

  return (
    <div className={clsx(style.optionsGrid)}>
      <div className={clsx(style.optionsTitle)}>{name}</div>
      <fieldset className={clsx(style.optionsContainer)}>
        <legend className={clsx(style.legend)}>{name}</legend>
        {options.map((option: string, index: number) => {
          const inputName = `${name}-option`;
          const optionId = `${name}-option-${index}`;
          const checked = selectedOptionIndex === index;

          return (
            <div
              className={clsx(style.itemWrapper, { [style.checkedItemLabel]: checked })}
              onClick={updateSelectedOptionIndex(index)}
              onKeyUp={handleKeyUp(index)}
              tabIndex={0}
              role="radio"
              key={optionId}
              aria-checked={checked}
            >
              <input
                className={clsx(style.input)}
                type="radio"
                value={index}
                name={inputName}
                id={optionId}
                checked={checked}
                onChange={updateSelectedOptionIndex(index)}
              />
              <label className={clsx(style.label)} htmlFor={optionId}>
                {option}
              </label>
            </div>
          );
        })}
      </fieldset>
    </div>
  );
};
